export default function frontEndTagging() {
    const createFrontEndLabel = (tag, identifier) => {
      const className = identifier.replace(/\s/g, '-').toLowerCase();
  
      const labelContainer = document.createElement('p');
      const labelText = document.createTextNode(tag);
      labelContainer.appendChild(labelText);
      labelContainer.classList.add(className);
      labelContainer.classList.add('ob-custom-label');
      return labelContainer;
    };
  
    const appendFrontEndLabel = (tile, label) => {
      const title = tile.querySelector('h3, .h3like');
      title.parentNode.insertBefore(label, title);
    };
  
    const applyFrontEndTags = (taggedTiles, frontEndLabels) => {
      taggedTiles.forEach((tile) => {
        if (!tile.classList.contains('ob-custom-tag')) {
          for (const tag in frontEndLabels) {
            const normalizedTags = tile.dataset.tags.toLowerCase().split(',');
            const regEx = new RegExp(tag, 'gi');
            if (regEx.test(normalizedTags)) {
              const frontEndLabel = createFrontEndLabel(frontEndLabels[tag], tag);
              appendFrontEndLabel(tile, frontEndLabel);
  
              // Add class to prevent re-processing
              tile.classList.add('ob-custom-tag');
            }
          }
        }
      });
    };
  
    const getTags = () => {
      const frontEndLabels = window.onbrandData.frontEndTags;
  
      const tiles = [...document.querySelectorAll('.tile.single:not(.cta):not(.loading-notifier)')];
      const taggedTiles = tiles.filter((tile) => tile.dataset.tags);
      if (taggedTiles) {
        applyFrontEndTags(taggedTiles, frontEndLabels);
      }
    };
  
    getTags();
  }


// WEBPACK FOOTER //
// ./scriptPartials/frontEndTagging.js